/** A local storage interface to fallback to inmemory storage in case of unavailable localStorage */
const isStorageAvailable = () => {
  let isLSAvailable;

  if (typeof isLSAvailable == "undefined") {
    try {
      const test = "test";
      window.localStorage.setItem(test, test);
      window.localStorage.removeItem(test);
      isLSAvailable = true;
    } catch {
      isLSAvailable = false;
    }
    return isLSAvailable;
  } else {
    return isLSAvailable;
  }
};

export const localStorage = {
  data: {},
  setItem: function (key: string, value: string) {
    if (isStorageAvailable()) {
      return window.localStorage.setItem(key, value);
    } else {
      return (this.data = {
        ...this.data,
        [key]: value,
      });
    }
  },
  getItem: function (key: string) {
    if (isStorageAvailable()) {
      return window.localStorage.getItem(key);
    } else {
      return this.data[key];
    }
  },
  removeItem: function (key: string) {
    if (isStorageAvailable()) {
      return window.localStorage.removeItem(key);
    } else {
      delete this.data[key];
    }
  },
  clear: function clear() {
    if (isStorageAvailable()) {
      return window.localStorage.clear();
    } else {
      this.data = {};
    }
  },
};

export const sessionStorage = {
  data: {},
  setItem: function (key: string, value: string) {
    if (isStorageAvailable()) {
      return window.sessionStorage.setItem(key, value);
    } else {
      return (this.data = {
        ...this.data,
        [key]: value,
      });
    }
  },
  getItem: function (key: string) {
    if (isStorageAvailable()) {
      return window.sessionStorage.getItem(key);
    } else {
      return this.data[key];
    }
  },
  removeItem: function (key: string) {
    if (isStorageAvailable()) {
      return window.sessionStorage.removeItem(key);
    } else {
      delete this.data[key];
    }
  },
  clear: function clear() {
    if (isStorageAvailable()) {
      return window.sessionStorage.clear();
    } else {
      this.data = {};
    }
  },
};
